const styleMap: Record<string, string> = {
  已反转: 'bg-secondary-100 text-secondary-800 border-secondary-200',
  已澄清: 'bg-secondary-100 text-secondary-800 border-secondary-200',
  持续发酵: 'bg-primary-100 text-primary-800 border-primary-200',
  进行中: 'bg-accent-100 text-accent-900 border-accent-200',
  官方回应: 'bg-accent-100 text-accent-900 border-accent-200',
};

export default function StatusBadge({ status }: { status: string }) {
  const cls = styleMap[status] ?? 'bg-background-200 text-foreground-700 border-background-300';

  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}